import styled from "styled-components";
import { media } from "../../theme/theme";

export const PPPrimaryCTAWrapper = styled.div`
    display: flex;
    justify-content: center;

    ${media.custom(850)} {
        position: relative;
        top: -80px;
    }
`;